import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-notifica-add',
	templateUrl: './notifica-add.component.html',
	styleUrls: ['./notifica-add.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificaAddComponent implements OnInit {
	@Input() datiAtto: any = {};
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	tipiNotificaSync: Subscription;
	tipiNotifica: any[] = [];

	esitiNotificaSync: Subscription;
	esitiNotifica: any[] = [];

	constructor(private cdr: ChangeDetectorRef, private dataService: DataService){
	}

	ngOnInit() {
		this.tipiNotificaSync = this.dataService.tipiNotifica$.subscribe(
			tipiNotifica => {
				this.tipiNotifica = tipiNotifica;
				if(tipiNotifica.length){
					this.datiAtto.tipoNotifica = tipiNotifica[0].id;
					this.cdr.markForCheck();
				}
			});
		this.esitiNotificaSync = this.dataService.esitiNotifica$.subscribe(
			esitiNotifica => {
				this.esitiNotifica = esitiNotifica;
				if(esitiNotifica.length){
					this.datiAtto.esitoNotifica = esitiNotifica[0].id;
					this.cdr.markForCheck();
				}
			});
	}

	notificaAddComplete(){
		return Boolean(this.datiAtto.id_prat && this.datiAtto.dataNotifica && this.datiAtto.tipoNotifica);
	}

	salvaNotifica(){
		console.log("salvaNotifica", this.datiAtto);
		if(!this.datiAtto.indiceNotifica){
			this.datiAtto.indiceNotifica = 'NULL';
			this.cdr.markForCheck();
		}
		let event: any = {
			aggiungiNotifica: true,
			uid: this.datiAtto.uid,
			id_prat: this.datiAtto.id_prat,
			setValue: {
				notifica_data: this.datiAtto.dataNotifica,
				notifica_indice: this.datiAtto.indiceNotifica,
				notifica_esito: this.datiAtto.esitoNotifica,
				notifica_tipo: this.datiAtto.tipoNotifica,
			},
			hide: true
		}
		console.log("INNER-NOTIFICA-ADD: event", event);
		this.innerEvents.emit(event);
		this.reset();
	}

	reset(){
		this.datiAtto.dataNotifica = '';
		this.datiAtto.indiceNotifica = '';
		this.datiAtto.tipoNotifica = '';
		this.datiAtto.esitoNotifica = '';
		this.cdr.detectChanges();
	}

	ngOnDestroy() {
		this.tipiNotificaSync.unsubscribe();
		this.esitiNotificaSync.unsubscribe();
	}
}
